import { render } from "./PricingPage.vue?vue&type=template&id=7a086ec5&scoped=true&ts=true"
import script from "./PricingPage.vue?vue&type=script&lang=ts"
export * from "./PricingPage.vue?vue&type=script&lang=ts"

import "./PricingPage.vue?vue&type=style&index=0&id=7a086ec5&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a086ec5"]])

export default __exports__